import { MultipleComplexValidator } from './multiple-complex.validator';
import { OrganizationLink } from '../../../../../swagger-api';

export class MultipleComplexTextInputWhitespaceOnlyValidator implements MultipleComplexValidator {
  public errorKey: string;
  public items: Array<OrganizationLink> = [];

  constructor(errorKey: string) {
    this.errorKey = errorKey;
  }

  get isValid(): boolean {
    return this.items.every((item) => item.organization_name.trim().length > 0);
  }
}
